import { render, staticRenderFns } from "./SubDistrictCharts.vue?vue&type=template&id=60d1974e&scoped=true"
import script from "./SubDistrictCharts.vue?vue&type=script&lang=js"
export * from "./SubDistrictCharts.vue?vue&type=script&lang=js"
import style0 from "./SubDistrictCharts.vue?vue&type=style&index=0&id=60d1974e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d1974e",
  null
  
)

export default component.exports